// extracted by mini-css-extract-plugin
export default {"cls1":"XaOWyFWUybbp8Jtg28bE","cls2":"r89o0C8eW6N7C1bdU1rG XaOWyFWUybbp8Jtg28bE"};